import { render, staticRenderFns } from "./WithCaptain.vue?vue&type=template&id=1a530c31&scoped=true"
import script from "./WithCaptain.vue?vue&type=script&lang=js"
export * from "./WithCaptain.vue?vue&type=script&lang=js"
import style0 from "./WithCaptain.vue?vue&type=style&index=0&id=1a530c31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a530c31",
  null
  
)

export default component.exports